<template>

<template-section v-if="!compact" :config="config" :linkName="linkName" :sectionName="sectionName"  @deSelectSection="$emit('deSelectSection')" @selectSection="$emit('selectSection')" @removeSection="$emit('removeSection')">
	<template v-slot:default>
		<h2 class="section-title">{{ title }}</h2>
		<div class="products" v-if="!config.drag">
			<div class="products-grid columns columns-3">
				<product v-for="(product, index) in products"
						:product="product"
						:editing="false"
						:key="index"></product>
			</div>
		</div>
	</template>

	<template v-slot:sectionEdit>
		<div class="section-title-edit">
			<label>Title</label>
			<input type="text" v-model="title">
			<br>
		</div>
		<a href="/dashboard/website/featured-products" target="_blank" class="website-link">Add Featured Products</a>
	</template>
</template-section>

<div v-else>Featured Products <i class="fas fa-grip-horizontal"></i></div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Product from './Product'
export default {
	name: 'featured-product-row',
	props: ['compact', 'config', 'options'],
    components: {
        'product': Product
    },
	data() {
		return {
			linkName: "/website/featured-products",
			sectionName: "Featured Products"
		}
	},
	computed: {
        ...mapGetters('website_module', [
            'getTemplateData'
        ]),
		localIndex() {
			if (!this.config) return
			return this.config.index - 1
		},
		title: {
			get() {
				return this.getTemplateData.pageSections[this.localIndex].options.title
			},
			set(value) {
				this.updateTemplateData({ path: `pageSections[${this.localIndex}].options.title`, value: value })
			}
		},
        products() {
			var products = []
			for (var i = 0; i < (3); i++) {
				products.push({
					title: "Product Name",
					product_id: "23456-5",
					upc: "012345678901",
					price: "349.99",
					image_url: 'https://media.shootingsportsmedia.com/templates/productsample-1.jpg'
				})
			}
			return products
		}
	},
    methods: {
        ...mapActions('website_module', [
            'updateTemplateData'
        ])
    }
}
</script>

<style lang="scss" scoped>
</style>
